








import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component
export default class KTable extends Vue {
  @Prop() title!: string;
}
